import styled from 'styled-components'

export const SelectWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

export const SelectLabel = styled.label`
	display: flex;
	font-size: 16px;
	font-weight: 500;
	color: ${props => props.theme.colors.text.primaryText};
	margin-bottom: 8px;
`

export const SelectButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: ${props => props.theme.sizes.forms.height};
	min-height: ${props => props.theme.sizes.forms.height};
	padding: 8px 16px;
	border: 1px solid
		${props =>
			props.$error
				? props.theme.colors.feedback.error
				: props.theme.colors.greys.defaultBorder};
	border-radius: 8px;
	background-color: ${props => props.theme.colors.brand.white};
	color: ${props =>
		props.$isEmpty
			? props.theme.colors.greys.disabledGrey
			: props.theme.colors.text.primaryText};
	font-size: 1rem;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	opacity: ${props => (props.disabled ? 0.6 : 1)};
	text-align: left;
	outline: none;

	&:focus {
		border-color: ${props => props.theme.colors.brand.blueOmint};
		box-shadow: 0 0 0 2px ${props => props.theme.colors.brand.backgroundBlue};
	}
`

export const TriggerText = styled.span`
	flex: 1;
	margin-right: 8px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const ErrorText = styled.span`
	display: block;
	font-size: 14px;
	color: ${props => props.theme.colors.feedback.error};
	margin-top: 4px;
`

export const ModalActions = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`

export const ListContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
	overflow-y: auto;
	padding-right: 4px;
	flex: 1;
	min-height: 0;
`

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
    align-items: flex-start;
`

export const SectionTitle = styled.p`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
	color: ${props => props.theme.colors.brand.lightBlue};
`

export const OptionRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 8px;
	padding: 6px 8px;
	border-radius: 8px;
	cursor: pointer;
    width: 100%;
	background-color: ${props =>
		props.$selected && !props.$hasCheckbox
			? props.theme.colors.brand.backgroundBlue
			: 'transparent'};

	&:hover {
		background-color: ${props => props.theme.colors.brand.backgroundBlue};
	}
`

export const Checkbox = styled.div`
	width: 18px;
	height: 18px;
	margin-top: 3px;
	flex-shrink: 0;
	border: 2px solid ${props => props.theme.colors.brand.blueOmint};
	border-radius: 4px;
	background-color: ${props =>
		props.$checked
			? props.theme.colors.brand.blueOmint
			: props.theme.colors.brand.white};
	display: flex;
	align-items: center;
	justify-content: center;
`

export const OptionInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
    align-items: flex-start;
`

export const OptionName = styled.span`
	font-size: 16px;
	line-height: 20px;
	color: ${props => props.theme.colors.text.primaryText};
`

export const OptionAddress = styled.span`
	font-size: 14px;
	line-height: 22px;
	color: ${props => props.theme.colors.text.secondaryText};
`

export const SectionDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${props => props.theme.colors.greys.dividerGray};
`

export const EmptyMessage = styled.p`
	margin: 0;
	font-size: 14px;
	color: ${props => props.theme.colors.text.secondaryText};
	text-align: center;
`
